export default __webpack_public_path__ + "static/media/formatEightPlayUnselected.2049523d.svg";